module.exports = __webpack_public_path__ + "img/shipping.c0bb7c46.svg";